var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartbeatFilled = function SvgHeartbeatFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.88 13.308a3.87 3.87 0 0 1 2.78-1.203c.815 0 1.603.258 2.257.738a3.83 3.83 0 0 1 2.246-.738c1.052 0 2.06.43 2.793 1.215a4.12 4.12 0 0 1 1.132 2.834 4.05 4.05 0 0 1-1.178 2.878l-3.841 3.63a1.685 1.685 0 0 1-2.314 0l-3.841-3.63-.04-.039a4.12 4.12 0 0 1-1.138-2.84 4.05 4.05 0 0 1 1.144-2.845",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.904 3.859a2.12 2.12 0 0 1 2.406 0l8.346 5.738a1 1 0 0 1-1.133 1.648l-8.346-5.738a.12.12 0 0 0-.14 0l-7.86 5.404a.12.12 0 0 0-.053.1v8.955c0 .067.055.122.123.122h3.368a1 1 0 1 1 0 2H4.247a2.123 2.123 0 0 1-2.123-2.123v-8.953c0-.7.344-1.353.92-1.75zM9.57 1.445a1 1 0 0 1-.278 1.387L2.555 7.324a1 1 0 0 1-1.11-1.665l6.737-4.49a1 1 0 0 1 1.387.276",
    clipRule: "evenodd"
  })));
};
export default SvgHeartbeatFilled;